import { RepositoryBuilder }        from 'alto-orm/lib/orm';
import KreditRepository, { Client } from 'alto-react-kredit/lib/models';

import Meal        from './meal';
import Order       from './order';
import Course      from './course';
import Canteen     from './canteen';
import Terminal    from './terminal';
import CourseGroup from './course_group';

const CanteenRepository = new RepositoryBuilder;

CanteenRepository.registerRelation(Meal,        '/canteen/crud/meals');
CanteenRepository.registerRelation(Order,       '/canteen/crud/orders');
CanteenRepository.registerRelation(Course,      '/canteen/crud/courses');
CanteenRepository.registerRelation(Canteen,     '/canteen/crud/canteens');
CanteenRepository.registerRelation(Terminal,    '/canteen/crud/terminals');
CanteenRepository.registerRelation(CourseGroup, '/canteen/crud/course_groups');

CanteenRepository.registerAllFrom(KreditRepository);

CanteenRepository.registerHasMany(Client,      Order);
CanteenRepository.registerHasMany(Meal,        Order);
CanteenRepository.registerHasMany(Canteen,     Meal);
CanteenRepository.registerHasMany(Course,      Meal,     'meals',     'courseName');
CanteenRepository.registerHasMany(CourseGroup, Course,   'courses',   'groupName');
CanteenRepository.registerHasMany(Canteen,     Terminal, 'terminals', 'defaultCanteenID');

CanteenRepository.registerBelongsTo(Order,    Client);
CanteenRepository.registerBelongsTo(Order,    Meal);
CanteenRepository.registerBelongsTo(Meal,     Canteen);
CanteenRepository.registerBelongsTo(Meal,     Course,      'course',           'courseName');
CanteenRepository.registerBelongsTo(Meal,     Course,      'additionalCourse', 'additionalCourseName');
CanteenRepository.registerBelongsTo(Course,   CourseGroup, 'group',            'groupName');
CanteenRepository.registerBelongsTo(Terminal, Canteen,     'defaultCanteen',   'defaultCanteenID');

export default CanteenRepository;
